if (!customElements.get('product-info-popup')) {
  customElements.define(
    'product-info-popup',
    class ProductInfoPopup extends HTMLElement {
      constructor() {
        super();
      }

      get sectionID() {
        return this.dataset.id;
      }

      connectedCallback() {
        this.openPopupButtons = this.querySelectorAll('[data-open-popup]');
        if (this.openPopupButtons.length === 0) return;
        this.popup = document.querySelector(`[data-popup="${this.openPopupButtons[0].dataset.openPopup}"]`);
        if (!this.popup) return;
        this.closePopupButtons = document.querySelectorAll(`[data-close-popup="${this.openPopupButtons[0].dataset.openPopup}"]`);
        this.popupOverlay = document.querySelector(`[data-popup-overlay][data-close-popup="${this.openPopupButtons[0].dataset.openPopup}"]`);
        this.scrollContainer = this.popup.querySelector('.product-info-popup-container');
        this.currentColor = this.querySelector('[data-current-color]');
        this.colors = this.querySelectorAll('.color-swatch');
        this.currentSize = this.querySelector('[data-current-size]');
        this.sizes = this.querySelectorAll('.size-option');
        this.setLoaded();
        this.openPopup();
        this.closePopup();
        this.changeColor();
        this.changeSize();
      }

      changeColor() {
        if (!this.currentColor && !this.colors) return;
        this.colors.forEach((color) => {
          color.addEventListener('mouseover', () => {
            const colorName = color.dataset.colorName;
            this.currentColor.innerText = colorName;
          });
        });
      }

      changeSize() {
        if (!this.currentSize && !this.sizes) return;
        this.sizes.forEach((size) => {
          size.addEventListener('mouseover', () => {
            const sizeName = size.dataset.sizeName;
            this.currentSize.innerText = sizeName;
          });
        });
      }

      openPopup() {
        this.openPopupButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this.lockScroll();
            this.popup.classList.add('active');
            this.popupOverlay.classList.add('active');
            this.popup.focus();
          });
        });
      }

      closePopup() {
        this.closePopupButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this.unlockScroll();
            this.popup.blur();
            this.popup.classList.remove('active');
            this.popupOverlay.classList.remove('active');
            this.scrollContainer.scrollTop = 0;
          });
        });
      }

      lockScroll() {
        const isFirefox = typeof InstallTrigger !== 'undefined';
        if (isFirefox) {
          document.body.style.overflow = 'hidden';
        } else {
          const scrollY = window.scrollY;
          document.body.dataset.scrollY = scrollY;
          document.body.style.position = 'fixed';
          document.body.style.top = `-${scrollY}px`;
          document.body.style.left = '0';
          document.body.style.right = '0';
          document.body.style.overscrollBehavior = 'none';
        }
      }

      unlockScroll() {
        const isFirefox = typeof InstallTrigger !== 'undefined';
        if (isFirefox) {
          document.body.style.overflow = 'auto';
        } else {
          const scrollY = document.body.dataset.scrollY || '0';
          document.body.removeAttribute('style');
          window.scrollTo({
            top: parseInt(scrollY, 10),
            behavior: 'instant',
          });
        }
      }

      setLoaded() {
        document.addEventListener('DOMContentLoaded', () => {
          setTimeout(() => {
            this.setAttribute('data-loaded', true);
          }, 100);
        });
      }
    },
  );
}
